import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class HomeService {

  constructor(private http: HttpClient) { }

  getCarrusel() {
    return this.http.get("https://fundacionbest.org.mx/Webapi/contenidoauto/api/Banner");
  }

}
